import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import { Link } from '@material-ui/core'
import { Link as RouterLink } from 'react-router-dom'
import ApprovalProjectSelector from '../../views/Approvals/Components/ApprovalProjectSelector'
import UserProfile from '../../views/Calendar/Header/UserProfile'
import { Container, MenuContainer } from '../../views/Calendar/Header/styles'
import { ApplicationTab, TabsContainer } from '../../views/Approvals/ApprovalView.styles'
import { views } from '../../views/Approvals/constants'
import CustomTooltip from '../CustomTooltip'

const MenuSection = ({
  person,
  selectedTab,
  setSelectedTab,
  latestInvoice,
  isLoadingProjects,
  projects,
  selectedProject,
  onProjectSelect,
  isProjectOverviewEnabled,
}) => {
  const stackInvoice = latestInvoice
    ? `https://stacks.keystonestrategy.io/invoices/${latestInvoice}`
    : `https://stacks.keystonestrategy.io/`

  const showProjectSelector =
    selectedTab === views.projectOverview && projects && projects.length > 0

  return (
    <Container>
      <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
        <UserProfile person={person} showEntriesBtn />
        {showProjectSelector && (
          <ApprovalProjectSelector
            projects={projects}
            selectedProject={selectedProject}
            onSelectProject={onProjectSelect}
          />
        )}
      </div>

      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <CustomTooltip title="Go to timesheets">
          <Link
            component={RouterLink}
            to="/"
            data-testid="dashboard.backToTimesheets"
            style={{ display: 'flex', alignItems: 'center', marginRight: '5px' }}
          >
            <ArrowBackIcon style={{ color: 'black' }} />
          </Link>
        </CustomTooltip>
        <MenuContainer style={{ gap: '10px' }}>
          <TabsContainer>
            {isProjectOverviewEnabled && (
              <ApplicationTab
                data-testid="dashboardTab.projectOverview"
                onClick={() => setSelectedTab(views.projectOverview)}
                selected={selectedTab === views.projectOverview}
                disabled={isLoadingProjects}
              >
                Project Overview
              </ApplicationTab>
            )}
            <ApplicationTab
              data-testid="dashboardTab.approvals"
              onClick={() => setSelectedTab(views.approvals)}
              selected={selectedTab === views.approvals}
              disabled={isLoadingProjects}
            >
              Time Approvals
            </ApplicationTab>
            <ApplicationTab
              data-testid="dashboardTab.expenses"
              onClick={() => setSelectedTab(views.expenses)}
              selected={selectedTab === views.expenses}
              disabled={isLoadingProjects}
            >
              Expense Approvals
            </ApplicationTab>
            <ApplicationTab
              data-testid="dashboardTab.wip"
              onClick={() => setSelectedTab(views.wip)}
              selected={selectedTab === views.wip}
              disabled={isLoadingProjects}
            >
              Value Delivery Review
            </ApplicationTab>
            <ApplicationTab
              data-testid="dashboardTab.invoiceManagement"
              onClick={() => setSelectedTab(views.invoiceManagement)}
              selected={selectedTab === views.invoiceManagement}
              disabled={isLoadingProjects}
            >
              Invoice Management
            </ApplicationTab>
            <ApplicationTab
              data-testid="dashboardTab.invoices"
              href={isLoadingProjects ? undefined : stackInvoice}
              target="_blank"
              rel="noopener noreferrer"
              disabled={isLoadingProjects}
            >
              Invoices
            </ApplicationTab>
          </TabsContainer>
        </MenuContainer>
      </div>
    </Container>
  )
}

MenuSection.propTypes = {
  person: PropTypes.object.isRequired,
  selectedTab: PropTypes.string.isRequired,
  projects: PropTypes.array,
  selectedProject: PropTypes.object,
  onProjectSelect: PropTypes.func,
  isProjectOverviewEnabled: PropTypes.bool,
}

export default MenuSection
